var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`text-capitalize ${_vm.cursor}`,on:{"click":function($event){_vm.showFullDate = !_vm.showFullDate}}},[_vm._v("\n    "+_vm._s(_vm.activityTimeDate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }